export const invoicesPerPage = 10
export const otherVariantsLimit = 5

export const langs = ['EN', 'UA', 'PL'] as const
